import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/privacy-policy/hero";
import PP from "../components/privacy-policy/content";
import CTA from "../components/porcelain-veneers/cta";
import Contact from "../components/universal/contact";
import Footer from "../components/universal/footer";

function Index() {
  return (
    <div>
      <Helmet>
        <title>Privacy Policy | Regent Dental</title>
        <meta
          name="description"
          content="Learn how Regent Dental safeguards your personal data. Our privacy policy offers full transparency, confidentiality, and GDPR-compliant dental care services."
        />
        <link
          rel="canonical"
          href="https://www.regent-dental.co.uk/privacy-policy"
        />
      </Helmet>
      <Navbar />
      <Header />
      <PP />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;
